export default __webpack_public_path__ + "static/media/filterRequest.9605af93.svg";